<template>
  <div>
    <h4>Opening Hours</h4>
    <div class="alert alert-info">
      Please enter times in 24 hour format. If the closing time is midnight, please enter 23:59 instead. If the opening time is midnight, enter 00:00. For any days where the station is closed all day, leave the fields blank.
    </div>
    <b-button class="btn-sm btn-success m-1" @click="copyTimeToWeekdays">Copy Monday times to all Weekdays</b-button> &nbsp;
    <b-button class="btn-sm btn-success m-1" @click="copyTimeToAllDays">Copy Monday times to all Weekdays & Weekend</b-button><br><br>
    <table class="openingHoursTable">
      <tr>
      <tr v-for="day in ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']">
        <th class="day-title">{{day}}</th>
        <td>
          <b-form-input type="number" step="1" max="23" min="0" v-model="openingHours[day].openHour"></b-form-input>
        </td>
        <td>
          <b-form-input type="number" step="1" max="59" min="0" v-model="openingHours[day].openMinutes"></b-form-input>
        </td>
        <td class="to-col">
          to
        </td>
        <td>
          <b-form-input type="number" step="1" max="23" min="0" v-model="openingHours[day].closeHour"></b-form-input>
        </td>
        <td>
          <b-form-input type="number" step="1" max="59" min="0" v-model="openingHours[day].closeMinutes"></b-form-input>
        </td>
      </tr>
    </table>
  </div>
</template>

<style scoped>
  .openingHoursTable input[type='text'] {
    max-width: 45px;
  }
</style>

<script>

  export default {
    name: "OpeningHours",
    props: {
      openingHours: Object
    },
    methods: {
      formatDigits: function(digits) {
        return digits.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
      },
      copyTimeToWeekdays: function() {
        let self = this;
        const openingHours = Object.assign({}, this.openingHours);

        ['Tuesday', 'Wednesday', 'Thursday', 'Friday'].forEach(function(day) {
          openingHours[day].openHour = openingHours['Monday'].openHour;
          openingHours[day].openMinutes = openingHours['Monday'].openMinutes;
          openingHours[day].closeHour = openingHours['Monday'].closeHour;
          openingHours[day].closeMinutes = openingHours['Monday'].closeMinutes;
        });
      },
      copyTimeToAllDays: function() {
        let self = this;
        const openingHours = Object.assign({}, this.openingHours);
        ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].forEach(function(day) {
          openingHours[day].openHour = openingHours['Monday'].openHour;
          openingHours[day].openMinutes = openingHours['Monday'].openMinutes;
          openingHours[day].closeHour = openingHours['Monday'].closeHour;
          openingHours[day].closeMinutes = openingHours['Monday'].closeMinutes;
        });
      }
    }
  }
</script>